import numeral from "numeral";
import React, { useEffect, useRef } from "react";
import { getTabId } from "../../utils/getTabId";
import { joinClasses } from "../../utils/joinClasses";
import { useTabContext } from "./tabs.context";
/**
 * Standard tab component, implemented as a button. Clicking it will reveal the
 * content for the selected tab.
 */
export const TabButton = ({ className, count, disabled, name, ...props }) => {
    const ref = useRef(null);
    const { onKeyDown, onTabClick, registerTab, selectedTab, tabListId, tabType, } = useTabContext();
    const tabId = getTabId(name);
    const selected = selectedTab === getTabId(name);
    // Register the tab ref with the parent tab bar to set focus on keydown
    useEffect(() => registerTab({ disabled, name: tabId, ref }), [disabled, tabId, registerTab]);
    return (React.createElement("button", { "aria-controls": `tabcontent-${tabId}`, "aria-selected": selected, className: joinClasses(["nxm-tab-button", className], {
            "nxm-tab-button-disabled": disabled,
            "nxm-tab-button-selected": selected,
        }), disabled: disabled, id: `tablist-${tabListId}-${tabId}`, ref: ref, role: "tab", tabIndex: selected ? 0 : -1, type: "button", onClick: () => onTabClick(tabId), onKeyDown: onKeyDown, ...props },
        React.createElement("span", { className: "nxm-tab-button-content" },
            name,
            count !== undefined && (React.createElement("span", { className: "nxm-tab-button-count" }, tabType === "secondary"
                ? `(${numeral(count).format("0,0")})`
                : numeral(count).format("0,0"))))));
};
